import React from "react";
import axios from "axios";
import FullCalendar from "@fullcalendar/react";
import resourceTimegridPlugin from "@fullcalendar/resource-timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import momentTimezonePlugin from "@fullcalendar/moment-timezone";
import {useRawTranslation} from "../../../effects/use_translation";
import Booking from "./booking";
import {useSelector} from "react-redux";
import moment from "moment-timezone"

const BookingCalendar = React.forwardRef(({
                                            editable,
                                            setEditable,
                                            eventsUrl,
                                            moveEventUrl,
                                            onBookingSelected,
                                          }, ref) => {
  const rawTranslation = useRawTranslation()
  const validRange = useSelector(state => state.valid_meeting_range)
  const fullcalendarLicenseKey = useSelector(state => state.fullcalendar_license_key)

  const url = new URL(window.location.href);
  const initialDate = url.searchParams.get("initial_date");

  const createEvent = (info) => {
    if (confirm("Do you want to add a new availability?")) {
      setEditable(false)
      axios.post(moveEventUrl, {
        start: info.dateStr,
        end: moment(info.dateStr).add(30, "minutes").toISOString(),
        event_type: "event",
      }).then(data => {
        if (data?.data && onBookingSelected && Object.keys(data.data).length !== 0) {
          onBookingSelected(data.data)
        }
      }).catch((error) => {
        console.error(error)
        alert(error.response?.data?.message || error)
      }).finally(() => {
        if (ref.current) {
          const api = ref.current.getApi()
          api.refetchEvents()
        }
        setEditable(true)
      })
    }
  }

  const updateEvent = (eventInfo) => {
    const startDisplayText = moment(eventInfo.event.start).format("h:mm a")
    const endDisplayText = moment(eventInfo.event.end || moment(eventInfo.event.start).add(1, "hours")).format("h:mm a")
    const confirmationText = `You will be available from ${startDisplayText} to ${endDisplayText}. Confirm?`

    if (confirm(confirmationText)) {
      setEditable(false)
      axios.post(moveEventUrl, {
        booked_table_id: eventInfo.event.id,
        start: eventInfo.event.start,
        end: eventInfo.event.end,
        old_start: eventInfo.oldEvent?.start,
        old_end: eventInfo.oldEvent?.end,
        event_type: eventInfo.event.extendedProps.eventType,
        event_title: eventInfo.event.extendedProps.eventTitle,
      }).then(data => {
        if (data?.data && onBookingSelected && Object.keys(data.data).length !== 0) {
          onBookingSelected(data.data)
        }

        if (!eventInfo.event.id) {
          eventInfo.event.setProp("id", data.data.id);
        }

        // Here it will be reverted because in finally the events are reloaded. So they are not shown double.
        if (!eventInfo.oldEvent && ref.current) {
          eventInfo.revert()
        }
      }).catch((error) => {
        eventInfo.revert()
        console.error(error)
        alert(error.response?.data?.message || error)
      }).finally(() => {
        if (ref.current) {
          const api = ref.current.getApi()
          api.refetchEvents()
        }
        setEditable(true)
      })
    } else {
      eventInfo.revert()
    }
  }

  const onEventDrop = (eventInfo) => {
    console.log("onEventDrop")
    updateEvent(eventInfo)
  }

  const onEventClick = (eventInfo) => {
    console.log("onEventClick")
    if (onBookingSelected) {
      onBookingSelected(eventInfo.event)
    }
  }

  const onEventChange = (eventInfo) => {
    console.log("onEventChange")
    updateEvent(eventInfo)
  }

  const onEventResize = (eventInfo) => {
    console.log("onEventResize")
    updateEvent(eventInfo)
  }

  const eventContent = (props) => {
    return <Booking {...props} />
  }

  return <div className={"row"}>
    <div className="col-12">
      <FullCalendar
        schedulerLicenseKey={fullcalendarLicenseKey}
        ref={ref}
        timeZone={"CET"}
        slotMinTime={"09:00:00"}
        slotMaxTime={"18:00:00"}
        dateClick={createEvent}
        allDaySlot={false}
        eventOverlap={false}
        locale={"de"}
        editable={editable}
        droppable={true}
        initialView={"timeGridWeek"}
        firstDay={5}
        aspectRatio={1.3}
        initialDate={initialDate}
        buttonText={{
          today: rawTranslation("booking_manager.today_button", "Heute"),
        }}
        validRange={validRange}
        events={eventsUrl}
        plugins={[resourceTimegridPlugin, interactionPlugin, momentTimezonePlugin]}
        eventDrop={onEventDrop}
        eventClick={onEventClick}
        eventResize={onEventResize}
        eventContent={eventContent}
        eventReceive={onEventChange}
      />
    </div>
  </div>
})

export default BookingCalendar